<template>
  <div
    v-if="blogArticles?.length > 0"
    :class="{ 'articles--full': fullWidthMobile }"
    class="blog-articles"
  >
    <div v-if="view !== 'inListing'" class="section-header">
      <h2 :class="['title', 'heading-m']">
        Полезные статьи
        <div class="link-text">
          <ui-ui-link
            path="https://price.ru/blog/"
            icon-after="right"
            target="_blank"
            font-class="body-l-regular"
            :font-weight="400"
            mode="link"
            :size-ico="isMobile ? '16' : '20'"
            @click="sendAnalitics()"
          >
            {{ !isMobile ? 'Смотреть всё' : 'Всё' }}
          </ui-ui-link>
        </div>
      </h2>
    </div>
    <div class="slider-wrap">
      <ui-multiple-swiper
        :free-mode="isMobile"
        class="all-article-container"
        :class="{ 'in-listing': view }"
        :space-between="spaceBetween"
        :per-group="view && !isLessTablet ? 2 : 1"
      >
        <ui-multiple-swiper-slide
          v-for="(el, index) in blogArticles"
          :key="`${el.id}_${index}_${type}`"
          class="article-snippet"
        >
          <component
            :is="component"
            :key="index"
            :article="el"
            class="multiple-item"
            @go-article="sendAnalitics()"
          />
        </ui-multiple-swiper-slide>
      </ui-multiple-swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { Navigation } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/vue';
import blogArticlesItem from './BlogArticlesItem.vue';
import blogArticlesItemListing from './BlogArticlesItemListing.vue';
import { timeOrAction } from '~/utils/timeOrAction';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { getArticles } from '~/api/global';
import { useTimeCalculation } from '~/composition/useTimeCalculation';
import type { BlogArticle, ModelItem } from '~/interfaces/api';

const props = defineProps({
  type: {
    type: String,
    default: 'main',
  },
  model: {
    type: Object as () => ModelItem,
    default: () => {},
  },
  articles: {
    type: Object as () => BlogArticle,
    default: () => {
      return { items: [], total: 0 };
    },
  },
  view: {
    type: String,
    default: '',
  },
  fullWidthMobile: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['change-data']);
const mediaStore = useMediaQueryStore();
const blogArticles = computed(() =>
  props.articles?.items?.length ? props.articles?.items : showArticles()
);
const isMobile = computed(
  () =>
    mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const isLessTablet = computed(
  () => mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm
);
const spaceBetween = computed(() =>
  mediaStore.isMd ? 12 : mediaStore.isEs || mediaStore.isSm ? 8 : 16
);
const { $ymAnyEvent } = useNuxtApp();
const modelID = computed(() =>
  props.model && props.model.id ? props.model.id : null
);

const component = computed(() => {
  return props.view === 'inListing'
    ? blogArticlesItemListing
    : blogArticlesItem;
});

async function showArticles() {
  const resData = await timeOrAction(getArticles(modelID.value));
  if (resData.success && 'data' in resData && resData.data?.items?.length > 0) {
    if (props.type === 'model') {
      emit('change-data', {
        key: 'articles',
        data: resData.data,
      });
    }
    return resData.data.items;
  }
  return [];
}

const sendAnalitics = () => {
  $ymAnyEvent('reachGoal', 'blog_index');
};

useTimeCalculation();
</script>
<style lang="scss" src="./BlogArticlesScss.scss" scoped></style>
